<div class="mastercard-termination-report">
  <PageControl
    :title="'Mastercard Merchant Termination Report'"
    :elements_query="sheet_elements"
  >
    <button
      class="btn btn-bg-green text-xs rounded-small shadow-sm me-2"
      @click="show_export_modal"
    >
      <i class="fas fa-download me-1"></i> Export Data
    </button>

    <!-- Export Modal -->
    <Teleport to="body">
      <div
        class="modal fade"
        :id="'export-modal-' + report_reference"
        tabindex="-1"
        aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header">
            <h6 class="modal-title fw-semibold text-muted">
              Export Mastercard Merchant Termination Report Data
            </h6>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label fw-bold">Select Data to Export:</label>
              <div class="form-check">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="export-inquiry-summary"
                  v-model="export_options.inquiry_summary"
                />
                <label class="form-check-label" for="export-inquiry-summary">
                  <strong>Inquiry Summary</strong>
                  <small class="d-block text-muted"
                    >Reference numbers, total matches, and inquiry
                    overview</small
                  >
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="export-merchant-details"
                  v-model="export_options.merchant_details"
                />
                <label class="form-check-label" for="export-merchant-details">
                  <strong>Merchant Details</strong>
                  <small class="d-block text-muted"
                    >Terminated merchant information, addresses, and termination
                    reasons</small
                  >
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="export-principal-info"
                  v-model="export_options.principal_information"
                />
                <label class="form-check-label" for="export-principal-info">
                  <strong>Principal Information</strong>
                  <small class="d-block text-muted"
                    >Principal/owner details associated with terminated
                    merchants</small
                  >
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="export-match-analysis"
                  v-model="export_options.match_analysis"
                />
                <label class="form-check-label" for="export-match-analysis">
                  <strong>Match Analysis</strong>
                  <small class="d-block text-muted"
                    >Merchant and principal matching scores and analysis</small
                  >
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  id="export-raw-json"
                  v-model="export_options.raw_json"
                />
                <label class="form-check-label" for="export-raw-json">
                  <strong>Raw JSON Data</strong>
                  <small class="d-block text-muted"
                    >Original unprocessed data from the Mastercard termination
                    inquiry</small
                  >
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold">Export Format:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="export-format-csv"
                  value="csv"
                  v-model="export_format"
                />
                <label class="form-check-label" for="export-format-csv">
                  CSV (Separate files for each table)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="export-format-excel"
                  value="excel"
                  v-model="export_format"
                />
                <label class="form-check-label" for="export-format-excel">
                  Excel (Multiple sheets in one file)
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="exportFormat"
                  id="export-format-json"
                  value="json"
                  v-model="export_format"
                />
                <label class="form-check-label" for="export-format-json">
                  JSON (JavaScript Object Notation)
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-2"
              @click="close_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-bg-green text-xs rounded-small shadow-sm"
              @click="export_data"
              :disabled="!has_selected_tables"
            >
              <i class="fas fa-download me-1"></i>
              Export Data
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>
  </PageControl>

  <PageComponent>
    <!-- HEADER SHEET -->
    <SectionSheet>
      <div
        class="container-fluid py-2 header d-flex align-items-center justify-content-between border-bottom mb-2"
      >
        <div class="d-flex">
          <img
            class="logo"
            width="295"
            height="125"
            src="@/assets/images/new_black_logo2.svg"
            alt="Logo"
          />
        </div>
        <div class="d-flex text-end">
          <div>
            <div class="h5 fw-bold mb-1">
              Mastercard Merchant Termination Report
            </div>
            <div class="text-muted text-xs">
              28 Fricker Rd,<br />
              Illovo, Johannesburg,<br />
              2196 South Africa<br />
              Website:
              <a
                href="https://www.goodpeopledata.com/"
                target="_blank"
                class="text-decoration-none text-muted"
                >www.goodpeopledata.com</a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm p-2 bg-white mb-2">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-credit-card me-2"></i>
            Mastercard Merchant Termination Summary
          </h6>
        </div>
        <div class="card-body">
          <p>
            This report summarizes the Mastercard merchant termination inquiry
            results with
            <span class="fw-bold text-dark">{{ total_merchant_matches }}</span>
            terminated merchant match(es) found (Reference ID:
            <span class="fw-bold text-dark">{{ inquiry_reference }}</span>).
          </p>
        </div>
      </div>

      <!-- Report Header -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-search me-2"></i>
                Merchant Termination Inquiry Report
              </h6>
              <div class="text-muted small">
                Reference: {{ inquiry_reference }} | Generated: {{
                formatted_current_date }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-2">
                    <span class="label-modern">Inquiry Reference:</span>
                    <div class="fw-semibold">{{ inquiry_reference }}</div>
                  </div>
                  <div class="mb-2">
                    <span class="label-modern">Page Offset:</span>
                    <div class="fw-semibold">{{ page_offset }}</div>
                  </div>
                  <div class="mb-2">
                    <span class="label-modern">Transaction Reference:</span>
                    <div class="fw-semibold">
                      {{ transaction_reference_number }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-2">
                    <span class="label-modern mb-2">Total Matches Found:</span>
                    <div>
                      <span
                        :class="matches_status_badge_class"
                        class="status-badge"
                      >
                        <i :class="matches_status_icon" class="me-1"></i>
                        {{ total_merchant_matches }}
                      </span>
                    </div>
                  </div>
                  <div class="mb-2">
                    <span class="label-modern">Terminated Merchants:</span>
                    <div class="fw-semibold">
                      {{ terminated_merchants_count }}
                    </div>
                  </div>
                  <div class="mb-2">
                    <span class="label-modern">Risk Level:</span>
                    <div>
                      <span
                        :class="risk_level_badge_class"
                        class="status-badge"
                      >
                        <i :class="risk_level_icon" class="me-1"></i>
                        {{ risk_assessment }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <!-- TERMINATED MERCHANTS SHEETS - Create separate SectionSheet for each group -->
    <SectionSheet 
      v-for="(merchantGroup, groupIndex) in paginatedMerchants" 
      :key="`merchants-${groupIndex}`"
      v-if="terminated_merchants.length > 0"
    >
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-ban me-2"></i>
                Terminated Merchants Found
                <span v-if="paginatedMerchants.length > 1" class="text-muted small">
                  (Page {{ groupIndex + 1 }} of {{ paginatedMerchants.length }})
                </span>
              </h6>
            </div>
            <div class="card-body">
              <div
                v-for="(merchant, index) in merchantGroup"
                :key="index"
                class="mb-4"
              >
                <div class="border rounded p-3 mb-3">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-2">
                        <span class="label-modern">Merchant Name:</span>
                        <div class="fw-semibold">
                          {{ merchant.merchant.name }}
                        </div>
                      </div>
                      <div class="mb-2">
                        <span class="label-modern">DBA Name:</span>
                        <div class="fw-semibold">
                          {{ merchant.merchant.doingBusinessAsName }}
                        </div>
                      </div>
                      <div class="mb-2">
                        <span class="label-modern">Merchant ID:</span>
                        <div class="fw-semibold">
                          {{ merchant.merchant.merchantId }}
                        </div>
                      </div>
                      <div class="mb-2">
                        <span class="label-modern">Phone Number:</span>
                        <div class="fw-semibold">
                          {{ merchant.merchant.phoneNumber }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-2">
                        <span class="label-modern">Date Opened:</span>
                        <div class="fw-semibold">
                          {{ formatDate(merchant.merchant.dateOpened) }}
                        </div>
                      </div>
                      <div class="mb-2">
                        <span class="label-modern">Date Closed:</span>
                        <div class="fw-semibold">
                          {{ formatDate(merchant.merchant.dateClosed) }}
                        </div>
                      </div>
                      <div class="mb-2">
                        <span class="label-modern mb-2"
                          >Termination Reason:</span
                        >
                        <div>
                          <span
                            :class="get_termination_reason_badge_class(merchant.merchant.reasonCode)"
                            class="status-badge"
                          >
                            <i
                              :class="get_termination_reason_icon(merchant.merchant.reasonCode)"
                              class="me-1"
                            ></i>
                            {{ merchant.merchant.reasonCodeDesc }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <span class="label-modern">Merchant Category:</span>
                        <div class="fw-semibold">
                          {{ merchant.merchant.merchantCategory }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Address Information -->
                  <div class="mt-3 pt-3 border-top">
                    <h6 class="mb-2">
                      <i class="fas fa-map-marker-alt me-2"></i>Address
                    </h6>
                    <div class="fw-semibold">
                      {{ format_merchant_address(merchant.merchant.address) }}
                    </div>
                  </div>

                  <!-- Comments if available -->
                  <div
                    v-if="merchant.merchant.comments"
                    class="mt-3 pt-3 border-top"
                  >
                    <h6 class="mb-2">
                      <i class="fas fa-comment me-2"></i>Comments
                    </h6>
                    <div class="fw-semibold">
                      {{ merchant.merchant.comments }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <!-- NO MERCHANTS FOUND SHEET -->
    <SectionSheet v-else>
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-ban me-2"></i>
                Terminated Merchants Found
              </h6>
            </div>
            <div class="card-body">
              <div class="text-center p-4">
                <i class="fas fa-check-circle fa-3x mb-3 text-success"></i>
                <h6 class="fw-semibold">No Terminated Merchants Found</h6>
                <p class="text-muted mb-0">
                  No matching terminated merchants were found in the Mastercard
                  database.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <!-- PRINCIPAL INFORMATION SHEETS - Create separate SectionSheet for each group -->
    <SectionSheet 
      v-for="(principalGroup, groupIndex) in paginatedPrincipals" 
      :key="`principals-${groupIndex}`"
      v-if="has_principal_data"
    >
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-user-tie me-2"></i>
                Principal Information
                <span v-if="paginatedPrincipals.length > 1" class="text-muted small">
                  (Page {{ groupIndex + 1 }} of {{ paginatedPrincipals.length }})
                </span>
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover table-compact">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Merchant</th>
                      <th class="text-xs">Principal Name</th>
                      <th class="text-xs">Address</th>
                      <th class="text-xs">Phone Number</th>
                      <th class="text-xs">Email</th>
                      <th class="text-xs">Date of Birth</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="principal in principalGroup"
                      :key="principal.merchant_name + principal.firstName"
                    >
                      <td class="text-xs fw-semibold">
                        {{ principal.merchant_name }}
                      </td>
                      <td class="text-xs">
                        {{ format_principal_name(principal) }}
                      </td>
                      <td class="text-xs">
                        {{ format_principal_address(principal.address) }}
                      </td>
                      <td class="text-xs">
                        {{ principal.phoneNumber || 'N/A' }}
                      </td>
                      <td class="text-xs">{{ principal.email || 'N/A' }}</td>
                      <td class="text-xs">
                        {{ format_masked_date(principal.dateOfBirth) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <!-- MATCH ANALYSIS SHEETS - Create separate SectionSheet for each group -->
    <SectionSheet 
      v-for="(merchantGroup, groupIndex) in paginatedMatchAnalysis" 
      :key="`match-analysis-${groupIndex}`"
    >
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-analytics me-2"></i>
                Match Analysis
                <span v-if="paginatedMatchAnalysis.length > 1" class="text-muted small">
                  (Page {{ groupIndex + 1 }} of {{ paginatedMatchAnalysis.length }})
                </span>
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover table-compact">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Merchant</th>
                      <th class="text-xs">Name Match</th>
                      <th class="text-xs">DBA Match</th>
                      <th class="text-xs">Phone Match</th>
                      <th class="text-xs">Address Match</th>
                      <th class="text-xs">Tax ID Match</th>
                      <th class="text-xs">Overall Risk</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(merchant, index) in merchantGroup"
                      :key="index"
                    >
                      <td class="text-xs fw-semibold">
                        {{ merchant.merchant.name }}
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_match_badge_class(merchant.merchantMatch.name)"
                          class="badge"
                        >
                          {{ format_match_score(merchant.merchantMatch.name) }}
                        </span>
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_match_badge_class(merchant.merchantMatch.doingBusinessAsName)"
                          class="badge"
                        >
                          {{
                          format_match_score(merchant.merchantMatch.doingBusinessAsName)
                          }}
                        </span>
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_match_badge_class(merchant.merchantMatch.phoneNumber)"
                          class="badge"
                        >
                          {{
                          format_match_score(merchant.merchantMatch.phoneNumber)
                          }}
                        </span>
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_match_badge_class(merchant.merchantMatch.address)"
                          class="badge"
                        >
                          {{ format_match_score(merchant.merchantMatch.address)
                          }}
                        </span>
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_match_badge_class(merchant.merchantMatch.nationalTaxId)"
                          class="badge"
                        >
                          {{
                          format_match_score(merchant.merchantMatch.nationalTaxId)
                          }}
                        </span>
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_overall_risk_badge_class(merchant)"
                          class="status-badge"
                        >
                          <i
                            :class="get_overall_risk_icon(merchant)"
                            class="me-1"
                          ></i>
                          {{ get_overall_risk_level(merchant) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <!-- TERMINATION DETAILS SHEETS - Create separate SectionSheet for each group -->
    <SectionSheet 
      v-for="(merchantGroup, groupIndex) in paginatedTerminationDetails" 
      :key="`termination-details-${groupIndex}`"
    >
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Termination Details
                <span v-if="paginatedTerminationDetails.length > 1" class="text-muted small">
                  (Page {{ groupIndex + 1 }} of {{ paginatedTerminationDetails.length }})
                </span>
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover table-compact">
                  <thead class="table-light">
                    <tr>
                      <th class="text-xs">Merchant Name</th>
                      <th class="text-xs">Merchant ID</th>
                      <th class="text-xs">Reason Code</th>
                      <th class="text-xs">Reason Description</th>
                      <th class="text-xs">Date Closed</th>
                      <th class="text-xs">Added By Acquirer</th>
                      <th class="text-xs">Created Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(merchant, index) in merchantGroup"
                      :key="index"
                    >
                      <td class="text-xs fw-semibold">
                        {{ merchant.merchant.name }}
                      </td>
                      <td class="text-xs">
                        {{ merchant.merchant.merchantId }}
                      </td>
                      <td class="text-xs">
                        {{ merchant.merchant.reasonCode }}
                      </td>
                      <td class="text-xs">
                        <span
                          :class="get_termination_reason_badge_class(merchant.merchant.reasonCode)"
                          class="badge"
                        >
                          {{ merchant.merchant.reasonCodeDesc }}
                        </span>
                      </td>
                      <td class="text-xs">
                        {{ formatDate(merchant.merchant.dateClosed) }}
                      </td>
                      <td class="text-xs">
                        {{ merchant.merchant.addedByAcquirerId }}
                      </td>
                      <td class="text-xs">
                        {{ formatDate(merchant.merchant.createdDate) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>

    <!-- DISCLAIMER SHEET -->
    <SectionSheet>
      <div class="card shadow-sm">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-info-circle me-2"></i>
            Disclaimer
          </h6>
        </div>
        <div class="card-body">
          <div class="disclaimer-content">
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-info-circle me-2"></i>General Information
            </h6>
            <p class="text-xs mb-4">
              This Mastercard Merchant Termination Report is prepared solely for
              the benefit of the intended recipient and is based on data
              obtained from the Mastercard Terminated Merchant File (TMF). While
              <strong> THE GOOD PEOPLE DATA COMPANY (PTY) LTD ('TGPDC')</strong>
              employs industry-standard practices to collect and process
              information, TGPDC does not guarantee, and expressly disclaims,
              the accuracy, completeness or timeliness of any data contained
              herein. The Report reflects the status of each record at the
              moment of generation and may not reflect subsequent changes.
            </p>
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-shield-lock me-2"></i>Data Privacy & Security
            </h6>
            <p class="text-xs mb-4">
              All merchant and personal information is processed in accordance
              with applicable data protection laws including POPIA (Protection
              of Personal Information Act) and PCI DSS requirements. This report
              contains sensitive financial data and should only be shared with
              authorized personnel who require access to this information for
              legitimate business purposes related to merchant risk assessment.
            </p>
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-exclamation-triangle me-2"></i>Risk Assessment
              Notice
            </h6>
            <p class="text-xs mb-4">
              The presence of terminated merchant matches indicates potential
              risk factors that should be carefully evaluated. This information
              should be used as part of a comprehensive risk assessment process
              and not as the sole determining factor for business decisions.
            </p>
            <div class="text-center text-muted mt-3">
              <p class="mb-0 text-xs">
                © {{ new Date().getFullYear() }} The Good People Data Company.
                All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-meta">
        <div class="text-muted small">
          Report Reference: {{ inquiry_reference }}
        </div>
        <div class="text-muted small">
          Generated: {{ formatted_current_date }}
        </div>
      </div>
    </SectionSheet>
  </PageComponent>
</div>